module.exports = __webpack_public_path__ + "img/file12.91c0041d.png";